<template>
    <div class="el-header--inner">
      <div>
        <!-- <img class="el-header--icon" src="@/assets/logo.png" /> -->
        <img class="el-header--icon" src="@/assets/ImgApplogo.png" />
        <span class="el-header--title">NiLIMo</span>
      </div>
      <div>
        <span class="el-header--username">{{ userName }}</span>
        <el-button class="el-header--signout" @click="click_user_signout()">ログアウト</el-button>
      </div>
    </div>
</template>

<script>
import { signout } from "../views/js/cognito";

export default {
  props: ['userName'],
  emits: ['calcHeaderSpace'],
  data() {
      return {
      }
  },
  mounted() {
    window.addEventListener('resize', this.setWindowSize);
    this.setWindowSize();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setWindowSize)
  },
  methods: {
    setWindowSize() {
      const top = document.getElementById('top');
      const sub = document.getElementById('sub');
      const subMenu = document.getElementById('submenu');
      const header = 80;
      const footerOffset = 44;
      const aside = 300;
      const hederSpace = 96;
      const minHeaderSpace = 10;
      const mainWidthMax = 1620;
      const mainWidthMin = 970;
      const mainWidthRatio = mainWidthMin / mainWidthMax;
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      top.style.width = width + "px";
      top.style.height = height + "px";
      sub.style.width = width - aside + "px";
      sub.style.height = height - header - footerOffset + "px";
      subMenu.style.height = height - header + "px";
      //
      let hederWidthRatio = (width - aside) / mainWidthMax;
      if (hederWidthRatio > 1.0) {
        hederWidthRatio = 1.0;
      } else if (hederWidthRatio < mainWidthRatio) {
        hederWidthRatio = mainWidthRatio;
      }
      let calcHeaderSpace = parseInt(hederSpace * ((hederWidthRatio - mainWidthRatio) / (1.0 - mainWidthRatio)));
      if (calcHeaderSpace < minHeaderSpace) {
        calcHeaderSpace = minHeaderSpace;
      }
      this.$emit("calcHeaderSpace", calcHeaderSpace);
    },
    click_user_signout: async function() {
      this.$store.commit('setCowMenuSelect', '');
      try {
        await signout();
        this.$router.push('/login')
      } catch {
        this.$router.push('/login')
      }
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    }
  },
  watch: {
  }
}
</script>